import styled from 'styled-components';

export const Container = styled.div`
  .subscription-now,
  .talk-to-us {
    background-color: #0d875e;
    color: #fff;
  }

  .full-width {
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    width: 100vw;
    text-align: center;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
  }

  li {
    font-size: 18px;
    font-weight: 300;
  }

  .material-icons {
    color: #0d875e;
  }

  .full-access-platform {
    border: 1px solid #c8c8c8;
    border-radius: 20px;
    padding: 35px;
  }

  .legal-support,
  .online-course-platform p {
    font-size: 18px;
  }

  .investment {
    background: #f5f5f5;
    border-radius: 20px;

    p {
      font-size: 18px;
    }
  }

  .talk-to-us {
    p {
      font-size: 18px;
    }
  }

  .btn-talk-to-us {
    font-size: 18px !important;
    color: #fff;
    text-decoration: underline;
  }
`;

export const ToggleWrapper = styled.div`
  display: inline-flex;
  border: 1px solid #ccc;
  border-radius: 999px;
  overflow: hidden;
  background-color: #fff;
  padding: 4px;
  justify-content: center;
  margin: 0 auto;
`;

export const ToggleButton = styled.button.withConfig({})<{ active: boolean }>`
  padding: 8px 20px 6px 20px;
  border: none;
  font-weight: bold;
  font-size: 0.9rem;
  border-radius: 999px;
  cursor: pointer;
  background-color: ${({ active }) => (active ? '#10a974' : 'transparent')};
  color: ${({ active }) => (active ? '#fff' : '#333')};
  transition: all 0.2s ease;

  &:hover {
    transform: none !important;
    border: none !important;
  }
`;
